export const decodeHTMLEntities = (src: string) => {
	const regex = /(.*)&([^;]+);(.*)/;
	let dest = src;
	let result = regex.exec(dest);
	while (result) {
		let char = '';
		let match = result[2].match(/^#[xX](\d+)$/);
		if (match) {
			// 16進数コード表記
			char = String.fromCharCode(parseInt(match[1], 16));
		} else {
			match = result[2].match(/^#(\d+)$/);
			if (match) {
				// 10進数コード表記
				char = String.fromCharCode(+match[1]);
			}
		}

		if (char === '') {
			switch (result[2]) {
				case 'quot':
					char = '"';
					break;
				case 'amp':
					char = '&';
					break;
				case 'lt':
					char = '<';
					break;
				case 'gt':
					char = '>';
					break;
				case 'nbsp':
					char = ' ';
					break;
			}
		}

		dest = result[1] + char + result[3];
		result = regex.exec(dest);
	}
	return dest;
};



// WEBPACK FOOTER //
// ./src/utils/Text.ts